import { CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/ui/button';

export default function SubscriptionRequired() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-warning/10">
        <CreditCard className="size-6 text-warning" />
      </div>

      <p className="text-sm font-medium text-foreground">Subscription Required</p>
      <p className="mt-1 max-w-xs text-center text-xs text-muted-foreground leading-relaxed">
        Your subscription has expired or is inactive. Please update your billing to continue.
      </p>

      <Button size="sm" className="mt-5" onClick={() => navigate('/settings/billing')}>
        Go to Billing Settings
      </Button>
    </div>
  );
}
